/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ checked: NonNullable<unknown>, mismatches: NonNullable<unknown>, remediated: NonNullable<unknown> }} Portals_Reconcile_DoneInputs */

const cs_portals_reconcile_done = /** @type {(inputs: Portals_Reconcile_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zkontrolováno ${i?.checked}: ${i?.mismatches} neshod, ${i?.remediated} opraveno.`)
};

const en_portals_reconcile_done = /** @type {(inputs: Portals_Reconcile_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Checked ${i?.checked}: ${i?.mismatches} mismatches, ${i?.remediated} remediated.`)
};

/**
* | output |
* | --- |
* | "Checked {checked}: {mismatches} mismatches, {remediated} remediated." |
*
* @param {Portals_Reconcile_DoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_reconcile_done = /** @type {((inputs: Portals_Reconcile_DoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Reconcile_DoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_reconcile_done(inputs)
	return cs_portals_reconcile_done(inputs)
});